import { Box, HStack, Grid } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InsuranceCompanyLogo from '../../../../../../../common/src/components/InsuranceCompanyLogo';
import { customMediaQuery } from '../../../../../../../common/src/utils/styledComponentsUtils';
import LabelValueWithSkeleton from '../../../../../components/offers/LabelValueWithSkeleton';
import useOffer from '../../../store/offer/useOffer';
import useProductContent from '../../../store/offer/useProductContent';
import OfferDetailsPicker from './risk-object-details/OfferDetailsPicker';

const OfferDetails: React.FC = () => {
  const { t } = useTranslation();
  const { offer } = useOffer();
  const productContent = useProductContent();

  return (
    <HStack w="100%" spacing="6">
      <Box
        maxW="24"
        maxH="20"
        display={{
          base: 'none',
          tablet: 'block',
        }}
      >
        <InsuranceCompanyLogo insuranceCompany={offer.info.company.key} />
      </Box>
      <Grid
        gap="2"
        w="100%"
        sx={{
          [customMediaQuery(0)]: { gridTemplateColumns: 'minmax(0, 1fr)' },
          [customMediaQuery(420)]: {
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr));',
          },
          [customMediaQuery(1024)]: { gridTemplateColumns: 'minmax(0, 1fr)' },
          [customMediaQuery(1300)]: {
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr));',
          },
          [customMediaQuery(1600)]: {
            gridTemplateColumns: 'repeat(4, minmax(0, 1fr));',
          },
        }}
      >
        <LabelValueWithSkeleton
          label={offer.info.company.name || t('Insurer')}
          isMediumFontWeight
        >
          {productContent?.insurance_company === 'bikmo'
            ? productContent?.guarantee_content[0].name
            : productContent?.insurance_content.name}
        </LabelValueWithSkeleton>
        <OfferDetailsPicker />
      </Grid>
    </HStack>
  );
};

export default OfferDetails;
